import { cn } from "@newxsystems/shared";
import { AbyssAction } from "../AbyssAction/AbyssAction";
import { AbyssMedia } from "../AbyssMedia/AbyssMedia";
import { AbyssRichText } from "../AbyssRichText/AbyssRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";

const widths = { small: "w-1/2", medium: "w-3/4", large: "w-full" } as const;

export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div className={cn("flex flex-col gap-5", centered && "items-center text-center")}>
      {eyebrow ? (
        <p
          className={cn("abyss-kicker text-frost before:bg-frost/55", centered && "before:hidden")}
        >
          {eyebrow}
        </p>
      ) : null}
      {image ? (
        <AbyssMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn("my-3", widths[imageWidth || "medium"])}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2 className="abyss-type-section max-w-[16ch] font-abyss-display font-medium">
          {heading}
        </h2>
      ) : null}
      {description ? (
        <AbyssRichText className="max-w-[65ch] text-frost" content={description} />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-3", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <AbyssAction action={button} key={`${button.href}-${index}`} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

CallToActionStacked.displayName = "Content::CallToActionStacked";
